import Entity from '../entity'

export default class VipCardOrder extends Entity<number>{
    vipCardOrderNo: string  = null;
    wxUserId: number  = null;
    tenantId: number  = null;
    userId: string  = null;
    userNo: string  = null;
    userName: string  = null;
    vipCardId: number  = null;
    vipCardName: string  = null;
    vipCardUnitPrice: string  = null;
    vipCardImageUrl: string  = null;
    coin: number = 0;
    paymentMethod: number  = null;
    paidAmount: string  = null;
    paidTime: Date  = null;
    status: number  = null;
    creationTime: string;
    remark: string  = null;
    discount: number;
    validMonths: number;
}